import { COMPANY } from "../lib/content";

const SECTIONS = [
    {
        title: "1. Acceptance of Terms",
        body: `By accessing or using the WorkAssign AI website and services, you agree to be bound by these Terms & Conditions. If you do not agree, please do not use our website or services. These terms apply to all visitors, users, customers and others who access the services of ${COMPANY.legal} ("WorkAssign AI", "we", "us", "our").`,
    },
    {
        title: "2. Services Description",
        body: "WorkAssign AI provides AI-powered business automation services including AI WhatsApp agents, AI calling agents, CRM management, follow-up automation and related business automation solutions. Service features, limits and pricing are described on our Pricing page and may be updated from time to time.",
    },
    {
        title: "3. Accounts & Subscriptions",
        body: "Paid plans are billed monthly in advance, along with any applicable one-time setup fee. You are responsible for maintaining the confidentiality of your account credentials and for all activity under your account. Plans can be upgraded as your usage grows; cancellations take effect at the end of the current billing cycle unless otherwise agreed in writing.",
    },
    {
        title: "4. Acceptable Use",
        body: "You agree not to misuse our services — including sending spam, unsolicited marketing, fraudulent, abusive or illegal content through AI agents configured on our platform. You are responsible for ensuring your use of AI calling and messaging complies with applicable laws and regulations, including telecom and data-protection rules in the jurisdictions where you operate.",
    },
    {
        title: "5. AI-Generated Interactions",
        body: "Our AI employees generate responses automatically based on the configuration and business information you provide. While we work hard to ensure accuracy and reliability, AI outputs may occasionally be imperfect. You remain responsible for reviewing critical communications and for the final business decisions taken on their basis.",
    },
    {
        title: "6. Intellectual Property",
        body: "All content on this website — including the WorkAssign AI name, logo, text, graphics and software — is the property of " + COMPANY.legal + " and is protected by applicable intellectual-property laws. You may not copy, reproduce or redistribute any part of the website without written permission.",
    },
    {
        title: "7. Limitation of Liability",
        body: "To the maximum extent permitted by law, WorkAssign AI shall not be liable for any indirect, incidental, special or consequential damages — including loss of profits, data or business opportunities — arising from the use or inability to use our services.",
    },
    {
        title: "8. Third-Party Links",
        body: "Our website contains links to third-party platforms (such as WhatsApp, Instagram, YouTube, X, Facebook and Google Maps). We are not responsible for the content, policies or practices of those platforms.",
    },
    {
        title: "9. Changes to Terms",
        body: "We may update these Terms & Conditions from time to time. Continued use of the website or services after changes are posted constitutes acceptance of the updated terms.",
    },
    {
        title: "10. Contact",
        body: "For questions about these terms, reach us via the Contact page or on WhatsApp at " + COMPANY.phoneDisplay + ".",
    },
];

export default function Terms() {
    return (
        <div className="mx-auto max-w-4xl px-4 py-20 sm:px-6 lg:py-24" data-testid="terms-page">
            <p className="font-mono2 text-xs uppercase tracking-[0.25em] text-cyan-400">Legal</p>
            <h1 className="mt-3 font-display text-4xl font-extrabold text-white" data-testid="terms-heading">Terms & Conditions</h1>
            <p className="mt-3 text-sm text-slate-500">Last updated: September 2026 · {COMPANY.legal}</p>
            <div className="mt-10 space-y-8">
                {SECTIONS.map((s) => (
                    <section key={s.title} data-testid={`terms-section-${s.title.split(".")[0]}`}>
                        <h2 className="font-display text-lg font-bold text-white">{s.title}</h2>
                        <p className="mt-2.5 text-sm leading-relaxed text-slate-400">{s.body}</p>
                    </section>
                ))}
            </div>
        </div>
    );
}
